import React, { useEffect, useState, useMemo } from 'react';
import { PagingQuery } from 'tea-component';
import Filter from '@/pages/intelligence/pages/TopCharts/Companies/components/GamesDetails/GamesStats/components/Sizer/RevenueDownloadFilter';
import { useIntl, connect, getLocale } from 'umi';
import { FILTER_EXTEND_NAMESPACE } from '@/pages/intelligence/models/filterExtend';
import { DBI_TOPCHARTS } from '@/pages/intelligence/models/topcharts';
import { updateDefaultTimeParams } from '@/pages/intelligence/pages/TopCharts/_config/detailDefaltfilterTime';
import TrendsCard from './TrendsCard';
import GamesCard from './GamesCard';
import CountriesCard from './CountriesCard';
import {
  getRevenueDownloadGamesData,
  getRevenueDownloadCountryData,
  getRevenueDownladTrendData,
  getRevenueDownloadGamesTable,
  getRevenueDownloadCountryTable,
} from './_utils';
import { useCompanyOptionList } from '@/pages/intelligence/pages/TopCharts/_hooks/useCompanyOptionList';
import { SortByItemType } from '@/pages/intelligence/components/TableComponents/components/SortBy';
import { changeTimetoDay } from '@/pages/intelligence/utils/topchartsUtils';
import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';
import useFilterExtend from '@/pages/intelligence/hooks/useFilterExtend';
import moment from 'moment';
import DetailDownload from '@/pages/intelligence/pages/TopCharts/Companies/components/GamesDetails/GamesStats/components/DetailDownload';
import { getCountriesExtendParams } from '@intelligence/utils/filterUtils';
import { COMBINEID_REG } from '@intelligence/utils/constant';

const GamesStatsRevenueDownload = (props: any) => {
  const {
    tabId,
    filterState,
    companyId,
    gameName,
    regionsCountries,
    setMainLoading,
    mainLoading,
    setDownloadParamsNormal,
    downloadParamsNormal,
    headerFixed,
    dataSources,
    showSelectType = false,
  } = props;

  const { formatMessage } = useIntl(); // 中英切换方法
  const locale = getLocale();

  const { isOperateDetail, detailFilterExtend, setDetailFilterExtend } =
    useFilterExtend({});

  const [trendLoading, setTrendLoading] = useState(true);
  const [trendLineList, setTrendLineList] = useState<any>([]);
  const [trendTableList, setTrendTableList] = useState<any>([]);
  const [trendCardStats, setTrendCardStats] = useState<any>({
    isLoading: true,
    isError: false,
    isNoData: true,
  });
  //   trend标题加上数据聚合方式
  const [trendComputeType, setTrendComputeType] = useState('');
  const [trendCount, setTrendCount] = useState('');

  const [gameTableLoading, setGameTableLoading] = useState(false);
  const [gameChartLoading, setGameChartLoading] = useState(true);
  const [gameChartType, setGameChartType] = useState<string>('pie');
  const [gameTotal, setGameTotal] = useState<number>(0);
  const [gameTableList, setGameTableList] = useState<any>([]);
  const [gameLineList, setGameLineList] = useState<any>([]);
  const [gameBarOrPieList, setGameBarOrPieList] = useState<any>([]);
  const [gameCardStats, setGameCardStats] = useState<any>({
    isLoading: true,
    isError: false,
    isNoData: true,
  });
  const [countriesTableLoading, setCountriesTableLoading] = useState(false);
  const [countriesChartLoading, setCountriesChartLoading] = useState(true);
  const [countriesChartType, setCountriesChartType] = useState<string>('pie');
  const [countriesTotal, setCountriesTotal] = useState<number>(0);
  const [countriesTableList, setCountriesTableList] = useState<any>([]);
  const [countriesLineList, setCountriesLineList] = useState<any>([]);
  const [countriesBarOrPieList, setCountriesBarOrPieList] = useState<any>([]);
  const [countriesCardStats, setCountriesCardStats] = useState<any>({
    isLoading: true,
    isError: false,
    isNoData: true,
  });
  const [regionOptions, setRegionOptions] = useState([]);
  const [filterLoading, setFilterLoading] = useState(true);

  const { mobileMetricsColumnsList } = useCompanyOptionList();
  const [fetchParams, setFetchParams] = useState({
    company_id: companyId,
    data_source: ['sensortower'], // dataSources === 'sensortower' ? 'company_sensortower' : 'appannie'
    entity_type: 'mobile',
    metrics: ['revenue', 'download'],
    order: 'desc',
    page: 1,
    page_size: 5,
    region_type: 'region', // 继承左右标签，继承从summary过来的
    regions: ['global'],
    start_date: `${moment().subtract(6, 'months').startOf('month').format('YYYY-MM-DD')}`,
    end_date: `${moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD')}`,
    period: 'month',
    order_metric: tabId,
    check_metric: tabId,
  });

  useEffect(() => {
    if (companyId && !filterLoading) {
      let newFetchParams = {
        ...fetchParams,
      };
      if (isOperateDetail === true) {
        /** 获取继承参数 */
        const extendParams = getExtendParams();
        newFetchParams = { ...newFetchParams, ...extendParams };
      }
      setFetchParams(newFetchParams);
      getPageData(newFetchParams);
    }
  }, [companyId, filterLoading]);

  const formatRegionParams = (markets: string[]) => {
    // 不同国家国家取交集,并且把交集的结果重新赋值到继承值中
    const { regionValues, filterExtendValue } = getCountriesExtendParams({
      regionOptions, // 国家筛选器options,
      defalutMarket: ['global'], // 没取到交集用的默认值
      disableNoChina: false,
      markets,
      filterExtend: detailFilterExtend,
    });
    setDetailFilterExtend(filterExtendValue);
    return regionValues;
  };

  const getExtendParams = () => {
    const newFetchParams: any = {};
    const timeExtend = detailFilterExtend[filterKeyMap.RANGE_TIME];
    const marketExtend = detailFilterExtend[filterKeyMap.REGION];

    if (marketExtend) {
      const regionValues = formatRegionParams(marketExtend?.markets);
      newFetchParams.region_type = regionValues?.regionType;
      newFetchParams.regions = regionValues?.regions;
    }
    newFetchParams.period =
      fetchParams.entity_type === 'mobile'
        ? 'month'
        : changeTimetoDay(timeExtend?.granularity);
    newFetchParams.start_date =
      timeExtend?.start_date || fetchParams.start_date;
    newFetchParams.end_date = timeExtend?.end_date || fetchParams.end_date;
    return newFetchParams;
  };

  const getTrendCardData = async (params) => {
    params = { ...params, source: params.data_source[0] };
    setTrendCardStats({
      ...trendCardStats,
      isLoading: true,
    });
    setMainLoading(true);
    setDownloadParamsNormal(params);
    const gameData = await getRevenueDownladTrendData(params, tabId);
    const {
      startDate,
      endDate,
      cardStats,
      lineData,
      tableData,
      total,
      trendCoundMsg,
    } = gameData;

    setTrendComputeType(trendCoundMsg?.type || '');
    setTrendCount(trendCoundMsg?.value || 0);
    setDownloadParamsNormal({
      ...params,
      start_date: startDate,
      end_date: endDate,
    });
    setTrendCardStats(cardStats);
    setTrendLineList(lineData || []);
    setTrendTableList(tableData || []);
    const updatedFetchParams: any = updateDefaultTimeParams({
      fetchParams: params,
      startDate,
      endDate,
      period: params.period,
      isTwoMonths: false,
    });
    setMainLoading(false);
    setFetchParams(updatedFetchParams);
  };

  const getGamesCardData = async (params) => {
    setGameCardStats({
      ...gameCardStats,
      isLoading: true,
    });
    const gameData = await getRevenueDownloadGamesData(
      params,
      tabId,
      params?.data_source[0],
    );
    const { cardStats, lineData, barOrPieData, tableData, total } = gameData;
    setGameCardStats(cardStats);
    setGameLineList(lineData);
    setGameBarOrPieList(barOrPieData);
    setGameTableList(tableData);
    setGameTotal(total);
  };

  const getCountriesCardData = async (params) => {
    setCountriesCardStats({
      ...countriesCardStats,
      isLoading: true,
    });
    const resData = await getRevenueDownloadCountryData(
      params,
      tabId,
      params?.data_source[0],
    );
    const { cardStats, lineData, barOrPieData, tableData, total } = resData;
    setCountriesCardStats(cardStats);
    setCountriesLineList(lineData);
    setCountriesBarOrPieList(barOrPieData);
    setCountriesTableList(tableData);
    setCountriesTotal(total);
  };

  const getPageData = async (params) => {
    // 返回状态， 折线， 表格，
    // 当筛选器更改时，使用新的筛选条件重新渲染卡片
    // 添加ID校验规则
    if (COMBINEID_REG.test(companyId)) {
      if (params.source) {
        params.data_source = [params.source];
      }
      getTrendCardData(params, tabId);
      getGamesCardData(params);
      getCountriesCardData(params);
    }
  };

  const handleConfirm = (value: any) => {
    const newFetchParams = {
      ...fetchParams,
      ...value,
      period: changeTimetoDay(value?.period),
    };
    getPageData(newFetchParams);
  };

  const onGameTableSortChage = async (e: SortByItemType) => {
    const newFetchParams = {
      ...fetchParams,
      order: e?.sortVal,
      order_metric:
        e?.ratioType === 1 ? `${e?.sortMetric}_ratio` : e?.sortMetric,
    };
    setGameTableList([]);
    setGameTableLoading(true);
    const data = await getRevenueDownloadGamesTable(newFetchParams, tabId);
    setGameTableList(data);
    setGameTableLoading(false);
  };

  const onGameTablePagingChange = async (e: PagingQuery) => {
    const newFetchParams = {
      ...fetchParams,
      page: e?.pageIndex || 1,
      page_size: e?.pageSize || 5,
    };
    setGameTableList([]);
    setGameTableLoading(true);
    const data = await getRevenueDownloadGamesTable(newFetchParams, tabId);
    setGameTableList(data);
    setGameTableLoading(false);
  };

  const onCountriesTableSortChage = async (e: SortByItemType) => {
    const newFetchParams = {
      ...fetchParams,
      order: e?.sortVal,
      order_metric:
        e?.ratioType === 1 ? `${e?.sortMetric}_ratio` : e?.sortMetric,
    };
    setCountriesTableList([]);
    setCountriesTableLoading(true);
    const data = await getRevenueDownloadCountryTable(newFetchParams, tabId);
    setCountriesTableList(data);
    setCountriesTableLoading(false);
  };

  const onCountriesTablePagingChange = async (e: PagingQuery) => {
    const newFetchParams = {
      ...fetchParams,
      page: e?.pageIndex || 1,
      page_size: e?.pageSize || 5,
    };
    setCountriesTableList([]);
    setCountriesTableLoading(true);
    const data = await getRevenueDownloadCountryTable(newFetchParams, tabId);
    setCountriesTableList(data);
    setCountriesTableLoading(false);
  };

  const onFilterInit = (params: any) => {
    const { loading, regionOptions } = params || {};
    setFilterLoading(loading);
    setRegionOptions(regionOptions);
  };

  const titleNowCur = useMemo(() => {
    return tabId == 'revenue'
      ? formatMessage({ id: `dbi_revenue` })
      : formatMessage({ id: `dbi_downloads` });
  }, [tabId, locale]);

  return (
    <>
      <div className="dbi-statsfilter-warp">
        <div className="statsfilter-warp-left">
          <Filter
            isTopCompanies
            timeFilterValues={{
              type: showSelectType ? 'date' : 'month',
              value: [fetchParams.start_date, fetchParams.end_date],
            }}
            showSelectType={showSelectType}
            buttonLogConfig={{}}
            filterConfirm={handleConfirm}
            filterReset={() => {}}
            filterInit={() => {}}
            onFilterInit={onFilterInit}
            // dataSources={dataSources}
          />
        </div>
        <div className="dbi-statsfilter-warp-right">
          <DetailDownload
            entityType={'mobile'}
            mainLoading={mainLoading}
            downloadParamsNormal={downloadParamsNormal}
            dataSource={fetchParams?.data_source[0]}
            gameName={gameName}
            segpaVa={'mobile'}
            segment={tabId}
          />
          {/* <Button icon="download" className="ns-btn--icon" title="下载" /> */}
        </div>
      </div>
      <TrendsCard
        lineData={trendLineList}
        tableData={trendTableList}
        dateType={fetchParams?.period}
        cardStatus={trendCardStats}
        trendComputeType={trendComputeType}
        trendCountValue={trendCount}
        columnsList={mobileMetricsColumnsList.trend[tabId]}
        entityType={'mobile'}
        setChartLoading={setTrendLoading}
        chartLoading={trendLoading}
        tabId={tabId}
        titleNow={titleNowCur}
        tabTitle={titleNowCur}
        dataSource={fetchParams?.data_source[0]}
      />
      <GamesCard
        headerFixed={headerFixed}
        lineData={gameLineList}
        tableData={gameTableList}
        barOrPieList={gameBarOrPieList}
        dateType={fetchParams?.period}
        startDate={
          fetchParams?.period === 'month'
            ? moment(fetchParams?.start_date).format('YYYY-MM')
            : fetchParams?.start_date
        }
        endDate={
          fetchParams?.period === 'month'
            ? moment(fetchParams?.end_date).format('YYYY-MM')
            : fetchParams?.end_date
        }
        dataSource={fetchParams?.data_source[0]}
        cardStatus={gameCardStats}
        tableTotal={gameTotal}
        columnsList={mobileMetricsColumnsList.gameCountry[tabId]}
        tableLoading={gameTableLoading}
        onTableSortChage={onGameTableSortChage}
        onTablePagingChange={onGameTablePagingChange}
        entityType={'mobile'}
        setChartLoading={setGameChartLoading}
        chartLoading={gameChartLoading}
        tabId={tabId}
        chartType={gameChartType}
        setChartType={setGameChartType}
        gameName={gameName}
        titleNow={titleNowCur}
      />

      <CountriesCard
        tableLoading={countriesTableLoading}
        lineData={countriesLineList}
        tableData={countriesTableList}
        barOrPieList={countriesBarOrPieList}
        dateType={fetchParams?.period}
        startDate={
          fetchParams?.period === 'month'
            ? moment(fetchParams?.start_date).format('YYYY-MM')
            : fetchParams?.start_date
        }
        endDate={
          fetchParams?.period === 'month'
            ? moment(fetchParams?.end_date).format('YYYY-MM')
            : fetchParams?.end_date
        }
        cardStatus={countriesCardStats}
        tableTotal={countriesTotal}
        columnsList={mobileMetricsColumnsList.gameCountry[tabId]}
        onTableSortChage={onCountriesTableSortChage}
        onTablePagingChange={onCountriesTablePagingChange}
        entityType={'mobile'}
        setChartLoading={setCountriesChartLoading}
        chartLoading={countriesChartLoading}
        tabId={tabId}
        chartType={countriesChartType}
        setChartType={setCountriesChartType}
        regionsCountries={regionsCountries}
        isGlobal={fetchParams.regions?.[0] === 'global'}
        titleNow={titleNowCur}
        dataSource={fetchParams?.data_source[0]}
      />
    </>
  );
};
export default connect((state: any) => {
  return {
    filterState: state[FILTER_EXTEND_NAMESPACE],
    topchartsState: state[DBI_TOPCHARTS],
  };
})(GamesStatsRevenueDownload);
